<div class="report-adjustments-comparation-component" fxLayout="column">
    <app-available-dates-selector
        [typeSelect]="'comparation'"
        [scenarios]="scenarios"
        [scenario]="options.comparation.scenario"
        [startDate]="options.endDate"
        [endDate]="options.comparation.date"
        [availableDates]="comparationAvailable()"
        [periodName]="options.period"
        [configs]="dropdownConfigs"
        (handleApply)="onApplyComparation($event)"
        (handleSelectScenario)="onSelectScenarioComparation($event)"
        (handleResetPeriod)="handleResetPeriod.emit()"
    >
        @if (
            ["dre", "dreComparation"].includes(report.type) ||
            report?.hasBalance
        ) {
            <app-form-dre-balance-options
                mobile-content
                [(form)]="formDreBalanceOptions"
                [options]="report.options"
            ></app-form-dre-balance-options>
        }
    </app-available-dates-selector>
</div>
